<template>
	<mu-container fluid class="px-0">
		<mu-row class="px-0">
			<mu-col class="px-0 banner d-flex justify-content-center align-items-center" style="background: #073F8C">
				<span class="title_header">{{ $t('module_bus.title') }}</span>
			</mu-col>
		</mu-row>
		<mu-row class="my-3 my-lg-5">
			<mu-col span="10" offset="1">
				<mu-carousel class="slider-buses">
					<mu-carousel-item v-for="(images, index) of images" :key="`images_${index}`" class="slider-item">
						<img :src="images.img_url" class="image_slider">
					</mu-carousel-item>
				</mu-carousel>
			</mu-col>
		</mu-row>
		<mu-row class="mb-3 mb-lg-5">
			<mu-col span="12" class="text-center py-3">
				<span class="texto-hover" style="color: #22528E">{{ $t('module_bus.text1_iframe') }}</span>
				<span class="texto-hover" style="color: #143D6F">{{ $t('module_bus.text2_iframe') }}</span>
			</mu-col>
			<mu-col span="10" offset="1">
				<div class="iframe_div">
					<iframe src="https://my.matterport.com/show/?m=U874hMqE4Q4" frameborder="0"
						class="iframe_component" />
				</div>
			</mu-col>
		</mu-row>
		<mu-row class="mb-3 mb-lg-4">
			<mu-col span="10" offset="1">
				<div class="text-center">
					<span class="title_amenitites">{{ $t('module_bus.title_amenities') }}</span>
				</div>
			</mu-col>
		</mu-row>
		<mu-row class="mb-3 mb-lg-5 d-flex justify-content-center align-items-center" gutter>
			<mu-col span="11">
				<mu-row class="justify-content-between">
					<mu-col span="12" sm="6" md="4" lg="4" xl="4" class="mt-2 px-1"
						v-for="(amenity, index) of amenities" :key="`amenities_${index}`">
						<div class="amenities_div">
							<img :src="amenity.img_url" class="image_services amenities_component">
							<div class="text-hover-amenities d-flex justify-content-center align-items-end">
								<div class="mb-5" style="width:200px">
									<div class="text-center">
										<span
											class="text-amenities">{{$t(`module_bus.amenities.${amenity.text}`)}}</span>
									</div>
								</div>
							</div>
						</div>
					</mu-col>
				</mu-row>
			</mu-col>
		</mu-row>
	</mu-container>
</template>

<script>

//Images Banners
import Asientos from "@@/images/buses/slider/asientos.jpg";
import Banos from "@@/images/buses/slider/banos.jpg";
import Bluetooth from "@@/images/buses/slider/bluetooth.jpg";
import Bus from "@@/images/buses/slider/bus.jpg";


// Images Amenities
import airconditioning from "@@/images/buses/amenities/airconditioning.jpg";
import reposet from "@@/images/buses/amenities/reposet.jpg";
import wifi from "@@/images/buses/amenities/wifi.jpg";
import screens from "@@/images/buses/amenities/screens.jpg";
import bathrooms from "@@/images/buses/amenities/bathrooms.jpg";
import connector from "@@/images/buses/amenities/connector.jpg";

// HELPERS
import _GlobalHelper from "@/store/helpers/global";

// VUEX
import { mapMutations, mapGetters } from "vuex";

const images = [
	{ img_url: Asientos },
	{ img_url: Banos },
	{ img_url: Bus },
	{ img_url: Bluetooth }
];

const amenities = [
	{ img_url: airconditioning, text: "airconditioning"},
	{ img_url: reposet, text: "reposet"},
	{ img_url: wifi, text: "wifi"},
	{ img_url: screens, text: "screens"},
	{ img_url: bathrooms, text: "bathrooms"},
	{ img_url: connector, text: "connector"},
];

export default {
	name: "bus",
	data() {
		return {
			images: images,
			amenities: amenities
		};
	},
	computed: {
		...mapGetters({
			lang: _GlobalHelper.getters.language,
		}),
		loading: {
			set(data) {
				this.set_loading(data);
			},
			get() { },
		},
		getDevice() {
			let user_agent = navigator.userAgent || navigator.vendor || window.opera;
			let sys = navigator.platform;

			if (/windows phone/i.test(user_agent)) {
				return "Windows";
			} else if (/android/i.test(user_agent)) {
				return "Android";
			} else if (/iPad|iPhone|iPod/.test(user_agent) && !window.MSStream) {
				return "iOS";
			} else if (sys.indexOf("Win") == 0) {
				return "Windows";
			} else if (sys.indexOf("Mac") == 0) {
				return "Mac";
			} else if (sys.indexOf("X11") == 0 || sys.indexOf("Linux") == 0) {
				return "Linux";
			} else {
				return "none";
			}
		},
	},
	methods: {
		...mapMutations({
			set_loading: _GlobalHelper.mutations.loading,
		}),
	},
	created() {
		this.loading = {show: true, message: `<h5>${this.$i18n.t("loading.global")}</h5>`, timeout_active: true};
	},
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Amaranth:ital,wght@0,400;0,700;1,400;1,700&display=swap');


.title_header{
	color: white;
	font-size: 80px;
	font-family: "Amino", sans-serif;
	font-weight: 800;
	font-style: normal;
}

.image_services {
	width: 100%;
	height: 480px;
}

.slider-item {
	width: 100%;
}

.slider-buses {
	width: 100%;
}

.image_slider {
	width: 100%;
	height: 100%
}

.iframe_div {
	position: relative;
	overflow: hidden;
}

.amenities_div {
	position: relative;
	overflow: hidden;
}

.iframe_component {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 0.3s ease-in-out;
}

.amenities_component {
	width: 100%;
	height: 100%;
	object-fit: cover;
	transition: transform 0.3s ease-in-out;
}

.amenities_div:hover .amenities_component {
	transform: scale(1.1);
}

.texto-hover {
	font-size: 48px;
	font-weight: 700;
	text-align: center;
}

.text-hover-amenities {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	color: #143D6F;
	font-size: 32px;
	font-weight: 400;
	opacity: 0;
	text-shadow: 1px 1px 2px #ffffff;
}


.amenities_div:hover .text-hover-amenities {
	opacity: 0.5;
	width: 100%;
	height: 100%;
	background-color: white;
}

.amenities_div:hover .text-amenities {
	opacity: 1;
}

.title_amenitites {
	color: #143D6F;
	font-size: 48px;
	font-family: "Inter", sans-serif;
	font-weight: 700;
	text-shadow: 1px 1px 2px #000000;
}

@media(min-width: 1700px) {
	.banner {
		width: 100%;
		height: 360px;
	}

	.slider-buses {
		width: 100%;
		height: 640px;
	}

	.iframe_div {
		width: 100%;
		height: 1020px;
	}

	.image_services {
		width: 100%;
		height: 480px;
	}
}

@media(max-width: 1700px) {
	.banner {
		width: 100%;
		height: 360px;
	}

	.slider-buses {
		width: 100%;
		height: 530px;
	}

	.iframe_div {
		width: 100%;
		height: 840px;
	}

	.image_services {
		width: 100%;
		height: 480px;
	}
}

@media(max-width: 1200px) {
	.title_header {
		font-size: 60px;
	}

	.banner {
		width: 100%;
		height: 300px;
	}

	.slider-buses {
		width: 100%;
		height: 450px;
	}

	.iframe_div {
		width: 100%;
		height: 720px;
	}

	.image_services {
		width: 100%;
		height: 380px;
	}
}

@media(max-width: 992px) {
	.title_header {
		font-size: 48px;
	}

	.banner {
		width: 100%;
		height: 250px;
	}
	.slider-buses {
		width: 100%;
		height: 375px;
	}

	.iframe_div {
		width: 100%;
		height: 595px;
	}

	.texto-hover {
		font-size: 30px;
	}

	.title_amenitites {
		font-size: 30px;
	}

	.image_services {
		width: 100%;
		height: 330px;
	}
}

@media(max-width: 768px) {

	.banner {
		width: 100%;
		height: 200px;
	}

	.slider-buses {
		width: 100%;
		height: 250px;
	}

	.iframe_div {
		width: 100%;
		height: 460px;
	}

	.image_services {
		width: 100%;
		height: 330px;
	}
}

@media(max-width: 576px) {
	.title_header {
		font-size: 40px;
	}

	.slider-buses {
		width: 100%;
		height: 250px;
	}

	.iframe_div {
		width: 100%;
		height: 345px;
	}

	.texto-hover {
		font-size: 25px;
	}

	.title_amenitites {
		font-size: 25px;
	}
}
</style>
